/**
 * Het scherm aan houden zolang er wordt opgenomen.
 *
 * Op een telefoon vergrendelt het scherm na een minuut of twee, en dan stopt de
 * browser de opname. Deze API is er sinds iOS 16.4 en in alle andere browsers;
 * waar hij ontbreekt gebeurt er niets en is er niets stuk.
 *
 * Een wake lock gaat verloren zodra het tabblad naar de achtergrond gaat. Komt
 * het terug, dan pakken we hem opnieuw: anders is het scherm na één keer
 * wegkijken alsnog vrij om uit te vallen.
 */
export async function houdSchermWakker(): Promise<() => void> {
  if (!('wakeLock' in navigator)) return () => {};

  let slot: WakeLockSentinel | null = null;
  let losgelaten = false;

  async function pak() {
    if (losgelaten || document.visibilityState !== 'visible') return;
    try {
      slot = await navigator.wakeLock.request('screen');
    } catch (err) {
      // Een geweigerd slot (batterijbesparing, geen gebruikersgebaar) is geen
      // reden om de opname te laten mislukken.
      console.warn('[opname] scherm blijft niet vanzelf aan', err);
    }
  }

  const bijTerugkomst = () => void pak();
  document.addEventListener('visibilitychange', bijTerugkomst);
  await pak();

  return () => {
    losgelaten = true;
    document.removeEventListener('visibilitychange', bijTerugkomst);
    void slot?.release().catch(() => {});
    slot = null;
  };
}
